(function () {
  function loadPopupScript() {
    if (window.__videoPopupLoaded) return;
    window.__videoPopupLoaded = true;
    if (!window.__videoPopupAssetUrl) return;
    var s = document.createElement('script');
    s.src = window.__videoPopupAssetUrl;
    s.defer = true;
    document.head.appendChild(s);
  }

  function init() {
    var btn = document.getElementById('scav-video-popup-button-wrapper');
    if (!btn) return;
    var obs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { loadPopupScript(); obs.disconnect(); }
    }, { rootMargin: '100px' });
    obs.observe(btn);
    btn.addEventListener('click', loadPopupScript, { once: true });
    btn.addEventListener('touchstart', loadPopupScript, { once: true, passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();